const headerData = [{
		types: "selection",
		columnwidth: 50,
	}, {
		prop: "id",
		label: "序号",
		columnwidth: 50,
	},
	{
		prop: "OrgCusCode",
		label: "原经销商编号",
	},
	{
		prop: "OrgCusName",
		label: "原经销商名称",
	},
	{
		prop: "NewCusCode",
		label: "关联经销商编号",
	},
	{
		prop: "NewCusName",
		label: "关联经销商名称",
	},
	{
		prop: "CreatorName",
		label: "创建人",
	},
	{
		prop: "CreateTime",
		label: "创建时间",
	},
	{
		prop: "EnabledName",
		label: "状态",
	},
];
export default headerData;